module.exports = __webpack_public_path__ + "img/wimpie-150px.399cf77f.png";